var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconLink = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-1.078 -1.089)" },
                React.createElement("path", { d: "M13.9,17.2c1.8,2.4,5.2,2.9,7.6,1.1c0.2-0.2,0.4-0.3,0.6-0.5l3.3-3.3c2.1-2.1,2.1-5.5,0-7.7\n\t\ts-5.5-2.1-7.7,0l-1.9,1.9" }),
                React.createElement("path", { d: "M18.2,15c-1.8-2.4-5.2-2.9-7.6-1.1c-0.2,0.2-0.4,0.3-0.6,0.5l-3.2,3.3c-2.1,2.1-2.1,5.5,0,7.7\n\t\ts5.5,2.1,7.7,0l0,0l1.9-1.9" })))));
});
export default IconLink;
//# sourceMappingURL=IconLink.js.map